import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import { parseStrapiContent } from "@lib/strapi/content";
import {
  StrapiStatDTO,
  StatDTO,
} from "@lib/strapi/dtos/components/shared/stat.dto";

export interface StrapiStatsSectionDTO extends StrapiDynamicZoneComponentDTO {
  eyebrow: string;
  heading: string;
  stats: StrapiStatDTO[];
}

export class StatsSectionDTO extends DynamicZoneComponentDTO {
  constructor() {
    super();
  }

  eyebrow: string;
  heading: string;
  stats: StatDTO[];
}
